import * as dd from 'dingtalk-jsapi';
import request from '@/utils/request';
import store from '@/store';
import { getDevice } from '@/utils/util'; 
import { Message } from 'element-ui';
/**
 * jsAPI 鉴权
 * @param {*} jsApiList // 需要使用的jsapi列表，注意：不要带dd
 * @param {*} errFn // 失败回调
 */
export async function jsApiConfig(jsApiList, errFn) {
    const device = getDevice();
    if (device.app === 'dingtalk') {
        const corpId = store.getters.corpId;
        if (!corpId) {
          console.log('钉钉鉴权时没有corpId，stop~~~~~~~~~~~~~');
          Message.error('钉钉鉴权时没有corpId');
          return;
        }
        // 鉴权前先拿到鉴权需要的参数
        const nonceStr = 'dingding-work-report-h5'; // 自定义固定字符串
        const params = {
          nonceStr,
          timeStamp: new Date().getTime(),
          url: location.href.split('#')[0]
        };
        // http.post('/user/dingding/sign/' + store.getters.corpId, params);
        const {
          success,
          data: { timeStamp, signStr, agentId }
        } = await request({
          url: '/user/dingding/sign/' + corpId, 
          data: params,
          method: 'post'
        });
        if (success) {
        // 开始鉴权
        dd.config({
            agentId, // 必填，微应用ID
            corpId: store.getters.corpId, // 必填，企业ID
            timeStamp: +timeStamp, // 必填，生成签名的时间戳
            nonceStr, // 必填，自定义固定字符串。
            signature: signStr, // 必填，签名
            type: 0, // 1, // 选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
            jsApiList: [
            // 必填，需要使用的jsapi列表，注意：不要带dd。
            'biz.contact.complexPicker',
            'biz.chat.openSingleChat',
            'biz.chat.pickConversation',
            'biz.chat.chooseConversationByCorpId',
            'device.audio.startRecord',
            'device.audio.stopRecord',
            'device.audio.play',
            'device.audio.pause',
            'device.audio.resume',
            'device.audio.stop',
            'device.audio.download',
            'device.audio.onPlayEnd',
            'device.audio.translateVoice',
            'device.audio.onRecordEnd',
            'device.base.getUUID',
            'biz.util.setScreenKeepOn',
            'biz.navigation.setMenu',
            'biz.clipboardData.setData'
            ]
        });

        dd.error(function(err) {
            Message.error('钉钉JSAPI鉴权失败：' + (err && err.errorMessage ? err.errorMessage : JSON.stringify(err)));
            errFn && errFn();
        });
        dd.ready(function() {
            document.addEventListener('pause', function(e) {
            // 在这里处理你的业务逻辑
            e.preventDefault();
            console.log('页面退到后台了~~~~~~~~~');
            const Audio = document.querySelector('#audio');
            Audio && Audio.pause();
            const VOICE = document.querySelector('.voiceItem.play');
            VOICE && VOICE.click();
            });
        });
        }
    }
}
// 获取企业code
export function getCode(corpId, fn) {
    if (!corpId) {
        Message.error('corpId 不能为空');
        return;
    }
    dd.ready(function() {
      dd.runtime.permission.requestAuthCode({
        corpId, // 企业id
        onSuccess: function(info) {
          fn && fn(info.code);
        },
        onFail: function(err) {
          Message.error('获取钉钉授权码失败：' + (err && err.errorMessage ? err.errorMessage : JSON.stringify(err)));
        }
      });
    });
}
// 获取token
export function getToken(corpId, code) {
    return request({
      url: `/user/login/${corpId}/${code}`,
      method: 'get'
    });
}

// imgPreview 钉钉图片预览
export function imgPreview(urls, current, success, fail) {
  console.log(urls, current, success, fail, 'urls, current, success, fail');
  dd.biz.util.previewImage({
    urls,
    current,
    onSuccess: function(res) {
      // 调用成功时回调
      success(res);
    },
    onFail: function(err) {
      // 调用失败时回调
      fail(err);
    }
  });
}
  

